export enum QueryParams {
  AUTO_START = 'auto_start',
  EMBED_TOKEN = 'token',
  SHOW_CHALLENGES = 'show_challenges',
  FORCE_START = 'force',
  FINISH_BUTTON_TARGET = 'finish_btn_target',
  FINISH_BUTTON_TEXT = 'finish_btn_text',
  FINISH_BUTTON_URL = 'finish_btn_url',
  FINISH_TEXT = 'finish_text',
  DISABLE_FEEDBACK = 'disable_feedback',
  CHECKS_CREATION_MODE = 'create_checks',
}
